import _ from 'lodash'
import React  from 'react'
import CarouselNuka from 'nuka-carousel'
import { PROP_TYPES } from 'widget/constants'
import {createStructuredSelector} from 'reselect'
import { PreviousButton, NextButton } from './Buttons'
import Slide from './Slide'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { newUserMessage }from 'App/actions'
import selectors from '../../store/selectors'

export let refCarousel

class Carousel extends React.Component {
  constructor(props) {
    super(props)

    let slides = props.message.get('slides')
    let resolves = []
    let promises = slides.map(() => new Promise(resolve => resolves.push(resolve) ))

    this.state = {
      resolves,
      promises,
    }
  }

  componentDidMount() {
    Promise.all(this.state.promises).then(res => {
      // fix wrong initial carousel height due to image not loaded
      if (refCarousel) {
        refCarousel.setDimensions()
      }
      // execute parent callback
      this.props.onReady()
    })
  }

  render() {
    const { message, handleButtonClick, theme } = this.props
    let slides = message.get('slides')

    return (!_.isEmpty(slides) && (
      <Container>
        <CarouselNuka
          ref={ref => {
            refCarousel = ref
          }}
          cellSpacing={20}
          framePadding="10px"
          renderCenterLeftControls={props => (<PreviousButton theme={theme} {...props}/>)}
          renderCenterRightControls={props => (<NextButton theme={theme} {...props}/>)}
          renderBottomCenterControls={() => null}
          heightMode="max"
        >
          {slides.map((slideProps, i) => {
            return (
              <Slide
                key={`slide_${Math.random()}`}
                onButtonClick={handleButtonClick}
                onReady={() => this.state.resolves[i](true)}
                {...slideProps}
              />)
          }
          )}
        </CarouselNuka>
      </Container>
    ))
  }
}

const Container = styled.div`
  .slider-list {
    -webkit-tap-highlight-color: transparent;
  }
`

Carousel.propTypes = {
  message: PROP_TYPES.CAROUSEL,
}

const mapStateToProps = createStructuredSelector({
  theme: selectors.selectTheme,
})

const mapDispatchToProps = dispatch => ({
  handleButtonClick: button => dispatch(newUserMessage(button)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Carousel)



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Carousel/index.js